module.exports = __webpack_public_path__ + "fonts/iconfont.a16b379e.ttf";